module.exports = __webpack_public_path__ + "img/nodejs.52da3fa4.svg";